/** Feature names reported to the feature sentiment widget, one per guest journey. */
export type FeatureSentimentName = "Secure Booking" | "Booking Journey" | "Preorder";

/**
 * Map a payment/confirmation `action` to the feature name used by the
 * feature sentiment widget.
 *
 * - `secure-your-booking` -> `Secure Booking`
 * - `book`                -> `Booking Journey`
 * - anything else         -> `Preorder`
 */
export function getFeatureNameForAction(action?: string): FeatureSentimentName {
  switch (action) {
    case "secure-your-booking":
      return "Secure Booking";
    case "book":
      return "Booking Journey";
    default:
      return "Preorder";
  }
}
